<template>
  <div class="m-card card-gradient">
    <!-- {{ item }} -->
    <div class="layout">
      <div class="header">
        <img :src="item.logo" alt="logo" v-if="item.logo != ''" />
        <h2 class="tb_700" v-else>{{ item.name }}</h2>
        <span>{{ item.subName }}</span>
      </div>
      <div class="content">
        <img :src="item.img" alt="" />
        <div style="position: relative">
          <DonutChart
            :chartOptions="chartOptions"
            :series="item.data"
            v-if="delay == 1"
          />
          <h4 class="text-center-chart tb_700">{{ item.data[0] }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonutChart from "@/components/ApexChart/DonutChart.vue";

export default {
  components: { DonutChart },
  props: {
    item: Object,
  },
  data() {
    return {
      delay: 0,
      chartOptions: {
        chart: {
          type: "donut",
        },
        labels: ["Active", "Inactive"],
        colors: this.item.color,
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.delay = 1;
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  //   flex-direction: column;
  grid: 70px 100px / auto;
  gap: 10px;
}

.tb_700 {
  font-weight: 700;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
    justify-content: center;
    h2{
        text-align: center;
    }
  img {
    height: 30px;
    max-width: 100%;
  }
  span {
    color: var(--text-color-2);
  }
}
.content {
  display: grid;
  grid: 100%/50% 50%;
  justify-items: center;
  align-items: center;
  img {
    width: 100%;
    max-height: 100%;
  }
}
.text-center-chart {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-gradient {
  background: linear-gradient(
    180deg,
    #0058cc 0%,
    var(--background-color-sidebar) 100px,
    var(--background-color-sidebar) 100%
  );
}
</style>